import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';
import { toast } from '@appcues/sonar';
import { TACTIC_ASSOCIATION_FAILED_MESSAGE } from './associate-tactic.saga';

/** Stable id so re-triggers update the existing toast instead of stacking. */
export const TACTIC_ASSOCIATION_TOAST_ID = 'tactic-association-failed';

/**
 * Surface the non-blocking tactic-association failure as a *persistent*,
 * manually-dismissable toast.
 *
 * The toast mounts on `document.body`, behind the builder's stacking context,
 * so while the post-create modal is still open — e.g. the flow step-type
 * picker with its blurred backdrop — it is obscured. An auto-dismiss timer
 * would expire before the user ever sees it. Persisting until dismissed
 * (`duration: Infinity`) means it's still there once that modal clears and the
 * blur is gone, and the close button lets the user dismiss it themselves.
 * See CampaignAndTacticApis.md §5.
 */
export const showTacticAssociationFailedToast = (): void => {
  toast.danger(
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
      {TACTIC_ASSOCIATION_FAILED_MESSAGE}
      <button
        type="button"
        aria-label="Dismiss"
        onClick={() => toast.dismiss(TACTIC_ASSOCIATION_TOAST_ID)}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          padding: 0,
          border: 'none',
          background: 'none',
          color: 'inherit',
          cursor: 'pointer',
          // react-hot-toast's container sets pointer-events: none (it inherits
          // down to here), which would swallow the click — re-enable it so the
          // dismiss button is actually clickable.
          pointerEvents: 'auto',
        }}
      >
        <FontAwesomeIcon icon={faXmark} />
      </button>
    </span>,
    { id: TACTIC_ASSOCIATION_TOAST_ID, duration: Infinity }
  );
};
